import { defineMessages } from 'react-intl'

const messages = {
  /**
   * Personal
   */
  personalDistanceImperial: defineMessages({
    headline: {
      id: 'yearInReview.2017.personalTotalDistanceImperial.headline',
      defaultMessage: 'Total\nMiles',
    },
    caption: {
      id: 'yearInReview.2017.personalTotalDistanceImperial.caption',
      defaultMessage: 'That\'s equal to running { captionValue } 5K races',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.personalTotalDistanceImperial.comparisonUnit',
      defaultMessage: '5K Races',
    },
  }),

  personalDistanceMetric: defineMessages({
    headline: {
      id: 'yearInReview.2017.personalTotalDistanceMetric.headline',
      defaultMessage: 'Total\nKilometers',
    },
    caption: {
      id: 'yearInReview.2017.personalTotalDistanceMetric.caption',
      defaultMessage: 'That\'s equal to running { captionValue } 5K races',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.personalTotalDistanceMetric.comparisonUnit',
      defaultMessage: '5K Races',
    },
  }),

  personalWorkouts: defineMessages({
    headline: {
      id: 'yearInReview.2017.personalWorkouts.headline',
      defaultMessage: 'Total\nWorkouts',
    },
    caption: {
      id: 'yearInReview.2017.personalWorkouts.caption',
      defaultMessage: 'That\'s working out daily for { captionValue } weeks in a row!',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.personalWorkouts.unit',
      defaultMessage: 'Weeks',
    },
  }),

  personalDuration: defineMessages({
    headline: {
      id: 'yearInReview.2017.personalDuration.headline',
      defaultMessage: 'Total\nHours',
    },
    caption: {
      id: 'yearInReview.2017.personalDuration.caption',
      defaultMessage: 'That\'s like working out 24 hours a day for over { captionValue } days',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.personalDuration.unit',
      defaultMessage: 'Days',
    },
  }),

  personalEnergy: defineMessages({
    headline: {
      id: 'yearInReview.2017.personalEnergy.headline',
      defaultMessage: 'Calories\nBurned',
    },
    caption: {
      id: 'yearInReview.2017.personalEnergy.caption',
      defaultMessage: 'You\'ve burned through { captionValue } slices of pizza!',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.personalEnergy.unit',
      defaultMessage: 'Pizza Slices',
    },
  }),

  personalChallenges: defineMessages({
    headline: {
      id: 'yearInReview.2017.personalChallenges.headline',
      defaultMessage: 'Challenges\nJoined',
    },
    caption: {
      id: 'yearInReview.2017.personalChallenges.caption',
      defaultMessage: 'You earned { captionValue } awards along the way!',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.personalChallenges.unit',
      defaultMessage: 'Awards Earned',
    },
  }),

  /**
   * Community
   */

  communityDistanceImperial: defineMessages({
    headline: {
      id: 'yearInReview.2017.communityDistanceImperial.headline',
      defaultMessage: 'Total\nMiles',
    },
    caption: {
      id: 'yearInReview.2017.communityDistanceImperial.caption',
      defaultMessage: 'That\'s { captionValue } trips across the continental U.S.',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.communityDistanceImperial.unit',
      defaultMessage: 'Trips Across The USA',
    },
  }),

  communityDistanceMetric: defineMessages({
    headline: {
      id: 'yearInReview.2017.communityDistanceMetric.headline',
      defaultMessage: 'Total\nKilometers',
    },
    caption: {
      id: 'yearInReview.2017.communityDistanceMetric.caption',
      defaultMessage: 'That\'s { captionValue } trips across the continental U.S.',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.communityDistanceMetric.unit',
      defaultMessage: 'Trips Across The USA',
    },
  }),

  communityWorkouts: defineMessages({
    headline: {
      id: 'yearInReview.2017.communityWorkouts.headline',
      defaultMessage: 'Total\nWorkouts',
    },
    caption: {
      id: 'yearInReview.2017.communityWorkouts.caption',
      defaultMessage: 'That\'s greater than the entire population of { captionValue }!',
    },
    comparisonStat: {
      id: 'yearInReview.2017.communityWorkouts.value',
      defaultMessage: '<h2>Mexico\'s</h2><p>Entire Population</p>',
    },
  }),

  communityDuration: defineMessages({
    headline: {
      id: 'yearInReview.2017.communityDuration.headline',
      defaultMessage: 'Total\nHours',
    },
    caption: {
      id: 'yearInReview.2017.communityDuration.caption',
      defaultMessage: 'That\'s like working out 24 hours a day for over { captionValue } years.',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.communityDuration.unit',
      defaultMessage: 'Years',
    },
  }),

  communityEnergy: defineMessages({
    headline: {
      id: 'yearInReview.2017.communityEnergy.headline',
      defaultMessage: 'Calories\nBurned',
    },
    caption: {
      id: 'yearInReview.2017.communityEnergy.caption',
      defaultMessage: 'That kind of energy lights the Empire State Building for over { captionValue } days.',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.communityEnergy.unit',
      defaultMessage: 'Days of Power',
    },
  }),

  communityRoutes: defineMessages({
    headline: {
      id: 'yearInReview.2017.communityRoutes.headline',
      defaultMessage: 'Routes\nCreated',
    },
    caption: {
      id: 'yearInReview.2017.communityRoutes.caption',
      defaultMessage: 'That\'s over { captionValue } per day, all over the world!',
    },
    comparisonUnit: {
      id: 'yearInReview.2017.communityRoutes.unit',
      defaultMessage: 'Routes per Day',
    },
  }),
}

export default messages



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Card/messages.js